import FloatingCard from './FloatingCard';
export default FloatingCard;
